import styled from "styled-components";

export const NotificationStyled = styled.div`
    @keyframes showNotification {
        from {
            transform: translateY(-100%);
            opacity: 0;
        }

        to {
            transform: translateY(0);
            opacity: 1;
        }
    }

    display: flex;
    justify-content: space-between;
    position: fixed;
    top: 5px;
    left: 16px;
    width: calc(100% - 32px);
    max-height: 108px;
    background: #fff;
    border-radius: 20px;
    padding: 24px;
    z-index: 1000;
    box-sizing: border-box;
    color: #000;
    animation: showNotification 0.5s ease;

    video {
        margin-left: 24px;
        margin-right: 12px;
        width: 45px;
        border-radius: 8px;
    }

    .button-close-notification {
        position: absolute;
        top: 12px;
        right: 12px;
        width: 12px;
        height: 12px;
        background: none;
    }
`;

export const NotificationTextContainerStyled = styled.div`
    @keyframes shake {
        0% {
        transform: translateX(-5px);
        }
        50% {
        transform: translateX(5px);
        }

        100% {
        transform: translateX(-5px);
        }
    }

    display: flex;
    flex-direction: column;
    justify-content: space-between;

    div {
        p {
            display: inline;
        }
    }

    svg {
        margin-left: 10px;
        width: 26px;
        height: 10px;
        animation: shake 800ms infinite ease-out;
    }
`;

export const NotificationTitleStyled = styled.p`
    font-weight: 700;
    font-size: 14px;
    line-height: 20px;
`;

export const NotificationBodyStyled = styled(NotificationTitleStyled)`
    font-weight: 400;

    span {
        font-weight: 700;
    }
`;